import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import ReactMarkdown from 'markdown-to-jsx';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import file from "./content/privacy.md";

function Markdown(props) {
    return <ReactMarkdown  {...props} />;
}

function Privacy() {


    const [markdown, setMarkdown] = React.useState("");

    React.useEffect(() => {
      fetch(file)
        .then((res) => res.text())
        .then((text) => setMarkdown(text));
    }, []);

  return (
      <Container>
        <Box sx={{ mt: 7, mb: 12 }}>
          <Typography variant="h3" gutterBottom marked="center" align="center">
            Privacy
          </Typography>
          <ReactMarkdown children={markdown} />
        </Box>
      </Container>
  );
}

export default Privacy;